import type { ProductInformation } from '@hotjar/product-catalog';

export function mapProductAllowancesToEntityProduct({
  effectiveNow,
  renewWith,
}: {
  renewWith: ProductInformation[];
  effectiveNow: ProductInformation[];
}): Array<{
  renewWith: ProductInformation | undefined;
  effectiveNow: ProductInformation;
}> {
  return effectiveNow.map((effectiveProduct) => {
    return {
      effectiveNow: effectiveProduct,
      renewWith: renewWith.find(
        (renewWithProduct) =>
          renewWithProduct.product.id === effectiveProduct.product.id &&
          effectiveProduct.allowance.sku !== renewWithProduct.allowance.sku,
      ),
    };
  });
}
